
import React from "react";
import { Accordion, AccordionPanel, Panel } from '@ronuse/norseu/core/panels';
import Helpers from "../../../utils/Helpers";
import { Button } from "@ronuse/norseu/core/buttons";
import { PasswordInput } from "@ronuse/norseu/core/form";
import { Scheme } from "@ronuse/norseu/core/variables";

export class PasswordInputPage extends React.Component {

    constructor(props) {
        super(props);
        this.willUnmount = false;
        this.previewPanels = React.createRef();
        this.previewPanels.current = [];
    }

    componentWillUnmount() {
        this.willUnmount = true;
    }

    buildDocumentation() {
        return (
            <React.Fragment>
                <Panel borderless style={{ marginTop: 40 }}>
                    <span className="norseu-showcase-component-page-preview-title">Basic</span>
                    <Accordion borderless multiple activeIndex={[0]}>
                        <AccordionPanel noheader nodivier className="norseu-showcase-component-page-preview">
                            <p className="documentation-p"></p>
                            <PasswordInput scheme={Scheme.PRIMARY}/>
                            
                            <div className="norseu-showcase-component-page-preview-buttons">
                                <i className="fa fa-code" onClick={(e) => this.previewPanels.current[0].toggle()}></i>
                                <i className="fa fa-copy" onClick={(e) => {Helpers.copyToClipboard(this.state.pageSource, [[57, 65]])}}></i>
                            </div>
                        </AccordionPanel>
                        {Helpers.getSourceInEditorR(this.state.pageSource, (ref) => this.previewPanels.current[0] = ref, [[57, 65]])}
                    </Accordion>
                </Panel>

                <Panel borderless style={{ marginTop: 40 }}>
                    <span className="norseu-showcase-component-page-preview-title">With toggle</span>
                    <Accordion borderless multiple activeIndex={[0]}>
                        <AccordionPanel noheader nodivier className="norseu-showcase-component-page-preview">
                            <p className="documentation-p"></p>
                            <div className="doc-list-view">
                                <PasswordInput scheme={Scheme.PRIMARY} placeholder="Toggle mask" toggleMask/>
                                <PasswordInput scheme={Scheme.PRIMARY} placeholder="Custom toggle mask" toggleMask toggleIcons={{
                                    show: 'fa fa-door-open',
                                    hide: 'fa fa-door-closed'
                                }}/>
                                <PasswordInput scheme={Scheme.PRIMARY} inputStyle={{ }} placeholder="Custom toggle mask" toggleMask toggleIcons={{
                                    show: <span className="norseu-pill norseu-secondary">Show</span>,
                                    hide: <span className="norseu-pill norseu-secondary">Hide</span>
                                }} leftIcon="fab fa-google" rightIcon="fab fa-apple"/>
                            </div>
                            
                            <div className="norseu-showcase-component-page-preview-buttons">
                                <i className="fa fa-code" onClick={(e) => this.previewPanels.current[0].toggle()}></i>
                                <i className="fa fa-copy" onClick={(e) => {Helpers.copyToClipboard(this.state.pageSource, [[57, 65]])}}></i>
                            </div>
                        </AccordionPanel>
                        {Helpers.getSourceInEditorR(this.state.pageSource, (ref) => this.previewPanels.current[0] = ref, [[57, 65]])}
                    </Accordion>
                </Panel>
            </React.Fragment>
        );
    }

    render() {
        return Helpers.buildComponentPage(this, {
            title: "PageTemplate",
            import_statement: "import { PasswordInput } from '@ronuse/norseu/core/form'",
            properties: this.properties,
            properties_info: "Inherits all the props from InputText",
            css_map: this.cssMap,
            ref_map: this.refMap,
            documentation: this.buildDocumentation(),
            page_source: this.state.pageSource,
            show_dialog: this.state.showSourceDialog,
            source_url: "https://raw.githubusercontent.com/ronuse/norseu/main/showcase/src/components/core/form/PasswordInputPage.js"
        });
    }

    state = {
        pageSource: '',
        showSourceDialog: false
    };

    cssMap = [

    ];

    properties = [
        { name: "hidden", type: "boolean", default: false, description: "Toggle password visibility" },
        { name: "toggleMask", type: "boolean", default: false, description: "Set whether to render the password visibility toggle" },
        { name: "toggleIcons", type: "object", default: {
            show: 'fa fa-eye',
            hide: 'fa fa-eye-slash'
        }, description: "The component toggle elements, can be Font Awesome icon class name or valid react element" },
        { name: "onShow", type: "function", default: "(event, ref)", description: "Callback invoked when the password visibility is on" },
        { name: "onHide", type: "function", default: "(event, ref)", description: "Callback invoked when the password visibility is off" },
    ];
    
    refMap = [
        { name: "value()", type: "function", description: "Returns the value of the component internal HTML element" },
        { name: "setValue(value)", type: "function", description: "Set the value of the component internal HTML element" },
        { name: "focus()", type: "function", description: "Send focus to the component" },
        { name: "getInternalElement()", type: "function", description: "Get the react reference to the internal element" },
        { name: "getState()", type: "function", description: "Get the current state of the component" },
        { name: "setState(newState)", type: "function", description: "Change the component state" },
    ]

}